import React from 'react'
import { Show, Datagrid, SimpleShowLayout, TextField, ReferenceManyField, EmailField, ShowButton, EditButton, FunctionField } from 'react-admin'
import CreateNewButton from '../../components/CreateNewButton'
import zoneAlerts from '../../defaults/ZoneAlerts'
import { BackToOrgButton, ShowOrgButton } from '../../components/Organization/OrgButtons.js'
import { parse } from "query-string";
import CustomShowActions from '../../components/CustomShowActions'

const ContactListShow = props => {
    const { organization_id } = parse(props.location.search);
    const CustomArray = (props) => {
        function createNotificationText() {
            let divs = []
            if (props.record.enabled_all_notifications) divs.push(<div style={{ fontSize: '0.8em', fontFamily: 'verdana', marginLeft: '10px' }}>ALL NOTIFICATIONS</div>)
            else for (let zone of zoneAlerts) {
                if (props.record[zone.column]) divs.push(<div style={{ fontSize: '0.8em', fontFamily: 'verdana', marginLeft: '10px' }}>{zone.name}</div>)
            }
            return divs
        }
        return (
            <div>
                <div style={{ fontSize: '0.7em', fontWeight: '300', fontFamily: 'verdana', color: 'darkGrey' }}>
                    Notifications:
                </div>
                <div>
                    {createNotificationText()}
                </div>
            </div>)
    }

    return (
        <Show {...props} actions={<CustomShowActions overrideOrgID={organization_id} />} title="Contact List" >
            <SimpleShowLayout>
                <BackToOrgButton organization_id={organization_id} />
                <ShowOrgButton />
                <TextField source="name" />
                <TextField source="description" />
                <CustomArray />
                <ReferenceManyField
                    label="Contacts"
                    reference="contacts"
                    target="contactlist_id">
                    <Datagrid>
                        <TextField source="firstName" />
                        <TextField source="lastName" />
                        <TextField source="phone" />
                        <EmailField source="email" />
                        <ShowButton />
                        <EditButton />
                    </Datagrid>
                </ReferenceManyField>
                <CreateNewButton createtype="contact" ddorgid={organization_id} redirectorigin="Contactlists" path="contacts" />
            </SimpleShowLayout>
        </Show>
    )


}


export default ContactListShow